import { getApp } from './getApp';
import type { Services } from './Services';

export function getService<T extends keyof Services>(
  serviceType: T,
): () => Services[T] {
  return () => getApp().service(serviceType);
}
